  document.querySelectorAll("[data-miipas-product]").forEach((root) => {
    if (root.dataset.bound === "true") return;
    root.dataset.bound = "true";

    const crumbs = root.querySelector(".pdp-crumbs");
    const crumbsList = crumbs?.querySelector("ol");
    const syncCrumbs = () => {
      if (!crumbs || !crumbsList) return;
      crumbs.classList.toggle("is-fit", crumbsList.scrollWidth <= crumbs.clientWidth + 1);
    };
    syncCrumbs();
    window.addEventListener("resize", syncCrumbs);

    const jsonEl = root.querySelector("[data-product-json]");
    const product = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const gallery = root.querySelector("[data-gallery]");
    const stage = gallery?.querySelector(".pdp-stage");
    const track = gallery?.querySelector("[data-stage-track]");
    const dots = [...root.querySelectorAll("[data-dots] .pdp-dot")];
    const thumbs = [...root.querySelectorAll("[data-thumbs] button")];
    const prevBtn = root.querySelector("[data-gallery-prev]");
    const nextBtn = root.querySelector("[data-gallery-next]");
    const realSlides = track ? [...track.querySelectorAll(".pdp-stage__slide")] : [];
    const realCount = realSlides.length;
    let slideIndex = realCount > 1 ? 1 : 0;
    let galleryIndex = 0;
    let looping = false;

    const pinGallery = () => {
      const header = document.querySelector(".miipas-header");
      if (!header) return;
      const top = Math.round(header.getBoundingClientRect().height) + 8;
      document.documentElement.style.setProperty("--pdp-sticky-top", `${top}px`);
    };
    pinGallery();
    window.addEventListener("resize", pinGallery);

    if (track && realCount > 1) {
      track.insertBefore(realSlides[realCount - 1].cloneNode(true), track.firstChild);
      track.append(realSlides[0].cloneNode(true));
      looping = true;
    }

    const stageWidth = () => stage?.clientWidth || 0;
    const xOf = (index) => -index * stageWidth();
    const setX = (x, animate) => {
      if (!track) return;
      track.style.transition = animate ? "transform 0.32s ease-out" : "none";
      track.style.transform = `translate3d(${x}px, 0, 0)`;
    };

    const paintIndex = (index) => {
      if (!realCount) return;
      galleryIndex = ((index % realCount) + realCount) % realCount;
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-current", i === galleryIndex);
        if (i === galleryIndex) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
      thumbs.forEach((thumb, i) => thumb.classList.toggle("is-current", i === galleryIndex));
    };

    const jumpTo = (index) => {
      slideIndex = index;
      setX(xOf(slideIndex), false);
      paintIndex(looping ? slideIndex - 1 : slideIndex);
    };

    const goTo = (index, animate) => {
      if (!realCount) return;
      if (!looping) {
        slideIndex = Math.max(0, Math.min(realCount - 1, index));
        setX(xOf(slideIndex), animate);
        paintIndex(slideIndex);
        return;
      }
      slideIndex = index;
      setX(xOf(slideIndex), animate);
      paintIndex(slideIndex - 1);
      if (!animate) {
        if (slideIndex === 0) jumpTo(realCount);
        else if (slideIndex === realCount + 1) jumpTo(1);
      }
    };

    const showImage = (index) => {
      if (!realCount) return;
      if (!looping) {
        goTo(index, true);
        return;
      }
      const current = ((slideIndex - 1) % realCount + realCount) % realCount;
      const next = ((index % realCount) + realCount) % realCount;
      if (next === current) return;
      goTo(next + 1, true);
    };

    track?.addEventListener("transitionend", (event) => {
      if (event.target !== track || event.propertyName !== "transform") return;
      if (!looping) return;
      if (slideIndex === 0) jumpTo(realCount);
      else if (slideIndex === realCount + 1) jumpTo(1);
    });

    prevBtn?.addEventListener("click", () => goTo(slideIndex - 1, true));
    nextBtn?.addEventListener("click", () => goTo(slideIndex + 1, true));
    dots.forEach((dot, i) => dot.addEventListener("click", () => showImage(i)));
    thumbs.forEach((thumb, i) => thumb.addEventListener("click", () => showImage(i)));

    if (stage && track && realCount > 1) {
      let dragging = false;
      let locked = false;
      let startX = 0;
      let startY = 0;
      let lastX = 0;
      let lastT = 0;
      let vel = 0;
      let baseX = 0;
      let pointerId = null;

      const endDrag = (event) => {
        if (!dragging) return;
        dragging = false;
        if (pointerId != null && stage.hasPointerCapture?.(pointerId)) {
          try { stage.releasePointerCapture(pointerId); } catch (err) {}
        }
        pointerId = null;
        if (!locked) return;
        locked = false;
        const dx = event.clientX - startX;
        const threshold = Math.min(72, stageWidth() * 0.18);
        let next = slideIndex;
        if (dx < -threshold || vel < -0.35) next += 1;
        else if (dx > threshold || vel > 0.35) next -= 1;
        goTo(next, true);
      };

      stage.addEventListener("pointerdown", (event) => {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        dragging = true;
        locked = false;
        pointerId = event.pointerId;
        startX = lastX = event.clientX;
        startY = event.clientY;
        lastT = performance.now();
        vel = 0;
        baseX = xOf(slideIndex);
        setX(baseX, false);
      });
      stage.addEventListener("pointermove", (event) => {
        if (!dragging) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (!locked) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dx) <= Math.abs(dy)) {
            dragging = false;
            return;
          }
          locked = true;
          try { stage.setPointerCapture(event.pointerId); } catch (err) {}
        }
        const now = performance.now();
        const dt = now - lastT;
        if (dt > 0) vel = (event.clientX - lastX) / dt;
        lastX = event.clientX;
        lastT = now;
        setX(baseX + dx, false);
      });
      stage.addEventListener("pointerup", endDrag);
      stage.addEventListener("pointercancel", endDrag);
      stage.addEventListener("touchmove", (event) => {
        if (locked) event.preventDefault();
      }, { passive: false });
    }

    jumpTo(looping ? 1 : 0);
    window.addEventListener("resize", () => setX(xOf(slideIndex), false));

    const minus = root.querySelector("[data-qty-minus]");
    const plus = root.querySelector("[data-qty-plus]");
    const qtyValue = root.querySelector("[data-qty-value]");
    const qtyInput = root.querySelector("[data-qty-input]");
    let qty = 1;
    const renderQty = () => {
      if (qtyValue) qtyValue.value = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (minus) minus.disabled = qty <= 1;
    };
    minus?.addEventListener("click", () => {
      qty = Math.max(1, qty - 1);
      renderQty();
    });
    plus?.addEventListener("click", () => {
      qty = Math.min(99, qty + 1);
      renderQty();
    });
    renderQty();

    const form = root.querySelector(".pdp-form");
    const wrapMark = "_gift_wrap";
    const wrapIdKey = "_gift_wrap_id";
    const propsOf = (item) => item.properties || {};
    const wrapInput = () => form?.querySelector("[data-gift-wrap]");
    const giftKeyOf = () => wrapInput()?.dataset.giftKey || "ギフトボックス";
    const giftValueOf = () => wrapInput()?.dataset.giftValue || "あり";
    const wrapIdOf = () => Number(wrapInput()?.dataset.variantId) || 0;
    const isWrapLine = (item) =>
      propsOf(item)[wrapMark] === "1" || (wrapIdOf() && Number(item.variant_id) === wrapIdOf());
    const wantsGift = (item) => {
      const props = propsOf(item);
      if (Number(props[wrapIdKey])) return true;
      return props[giftKeyOf()] === giftValueOf();
    };
    const goodsCount = (cart) =>
      (cart.items || []).reduce((sum, item) => (
        isWrapLine(item) ? sum : sum + Number(item.quantity || 0)
      ), 0);
    const yenText = (cents) => Math.round(Math.max(0, Number(cents) || 0) / 100).toLocaleString("ja-JP");
    const addedModal = document.querySelector("[data-cart-added]");
    const addedHome = addedModal?.querySelector("[data-cart-added-home]");
    const addedChoose = addedModal?.querySelector("[data-cart-added-choose]");
    const addedTitle = addedModal?.querySelector("[data-cart-added-title]");
    const addedOptions = addedModal?.querySelector("[data-cart-added-options]");
    const addedPickPrice = addedModal?.querySelector("[data-cart-added-pick-price]");
    const addedPickAdd = addedModal?.querySelector("[data-cart-added-pick-add]");
    const addedBack = addedModal?.querySelector("[data-cart-added-back]");
    const addedTitleHome = addedTitle?.textContent || "カートに入れました";
    const addedAddLabel = "カートに入れる";
    const addedDoneLabel = "完了";
    const addedDoneTimers = new WeakMap();
    const btnLabel = (btn) => (btn?.textContent || "").replace(/\s+/g, "");
    const yenAmount = (value) => Number(String(value ?? "0").replace(/,/g, "") || 0).toLocaleString("ja-JP");
    let addedPick = null;
    const finishAddedBtn = (btn) => {
      if (!btn) return;
      btn.removeAttribute("aria-busy");
      btn.disabled = true;
      btn.textContent = addedDoneLabel;
      const prev = addedDoneTimers.get(btn);
      if (prev) window.clearTimeout(prev);
      addedDoneTimers.set(btn, window.setTimeout(() => {
        btn.disabled = false;
        if (btn.textContent === addedDoneLabel) btn.textContent = addedAddLabel;
      }, 1600));
    };
    const resetAddedBtn = (btn) => {
      if (!btn) return;
      const prev = addedDoneTimers.get(btn);
      if (prev) window.clearTimeout(prev);
      addedDoneTimers.delete(btn);
      btn.removeAttribute("aria-busy");
      btn.disabled = false;
      btn.textContent = addedAddLabel;
    };
    const finishAddedFlash = (busyBtn, doneBtn) => {
      resetAddedBtn(busyBtn);
      if (doneBtn && doneBtn !== busyBtn) resetAddedBtn(doneBtn);
      showAddedHome();
      window.MiipasFlash?.show(window.MiipasFlash?.MSG?.cartAdded || "カートに入れました");
    };
    const showAddedHome = () => {
      if (addedHome) addedHome.hidden = false;
      if (addedChoose) addedChoose.hidden = true;
      if (addedBack) addedBack.hidden = true;
      if (addedTitle) addedTitle.textContent = addedTitleHome;
      addedPick = null;
    };
    const findAddedVariant = (data, selected) =>
      (data.variants || []).find((variant) =>
        (variant.options || []).every((option, index) => option === selected[index])
      );
    const paintAddedChoose = () => {
      if (!addedPick) return;
      const { data, selected } = addedPick;
      addedOptions?.querySelectorAll(".pdp-options__list").forEach((group, optionIndex) => {
        group.querySelectorAll("button").forEach((button) => {
          const value = button.dataset.value;
          const possible = (data.variants || []).some((variant) =>
            variant.available
            && variant.options[optionIndex] === value
            && variant.options.every((option, index) => index === optionIndex || option === selected[index])
          );
          button.disabled = !possible;
          button.setAttribute("aria-pressed", selected[optionIndex] === value ? "true" : "false");
        });
      });
      const next = findAddedVariant(data, selected);
      if (addedPickPrice) {
        addedPickPrice.textContent = yenText(
          Math.round(Number(String(next?.price ?? "0").replace(/,/g, "") || 0) * 100)
        );
      }
      if (addedPickAdd && addedPickAdd.getAttribute("aria-busy") !== "true" && addedPickAdd.textContent !== addedDoneLabel) {
        addedPickAdd.disabled = !next?.available;
        addedPickAdd.textContent = next?.available ? "カートに入れる" : "売り切れ";
      }
    };
    const openAddedChoose = (card) => {
      const source = card?.querySelector("[data-variants]");
      if (!source || !addedChoose || !addedOptions) return false;
      let data = null;
      try {
        data = JSON.parse(source.textContent);
      } catch {
        return false;
      }
      const first = (data.variants || []).find((variant) => variant.available) || data.variants?.[0];
      if (!first) return false;
      addedPick = { card, data, selected: [...(first.options || [])] };
      if (addedTitle) addedTitle.textContent = data.title || addedTitleHome;
      addedOptions.replaceChildren();
      (data.options || []).forEach((option, optionIndex) => {
        const field = document.createElement("fieldset");
        const legend = document.createElement("legend");
        legend.textContent = option.name;
        const list = document.createElement("div");
        list.className = "pdp-options__list";
        list.dataset.optionIndex = String(optionIndex);
        (option.values || []).forEach((value) => {
          const button = document.createElement("button");
          button.type = "button";
          button.dataset.value = value;
          button.textContent = value;
          list.append(button);
        });
        field.append(legend, list);
        addedOptions.append(field);
      });
      paintAddedChoose();
      if (addedHome) addedHome.hidden = true;
      if (addedBack) addedBack.hidden = false;
      addedChoose.hidden = false;
      return true;
    };
    const paintAddedSums = (cart) => {
      const countEl = addedModal.querySelector("[data-cart-added-count]");
      const totalEl = addedModal.querySelector("[data-cart-added-total]");
      if (countEl) countEl.textContent = String(goodsCount(cart));
      if (totalEl) totalEl.textContent = yenText(cart.total_price || 0);
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { itemCount: goodsCount(cart) } }));
    };
    const syncAddedUpsell = (cart) => {
      const upsell = addedModal?.querySelector("[data-cart-added-upsell]");
      if (!upsell) return;
      upsell.querySelectorAll("[data-product-id]").forEach((card) => {
        card.hidden = false;
      });
      upsell.hidden = upsell.querySelectorAll("[data-product-id]").length < 1;
    };
    const openAddedModal = (cart) => {
      if (!addedModal) {
        location.href = `${window.Shopify.routes.root}cart`;
        return;
      }
      showAddedHome();
      paintAddedSums(cart);
      syncAddedUpsell(cart);
      addedModal.hidden = false;
      document.body.classList.add("is-modal-open");
    };
    const closeAddedModal = () => {
      if (!addedModal) return;
      showAddedHome();
      addedModal.hidden = true;
      document.body.classList.remove("is-modal-open");
    };
    const addUpsellVariant = (variantId, busyBtn, doneBtn) => {
      if (adding || !variantId) return;
      adding = true;
      if (busyBtn) {
        busyBtn.setAttribute("aria-busy", "true");
        busyBtn.disabled = true;
      }
      readCart().then((cart) => {
        const match = (cart.items || []).find((item) =>
          Number(item.variant_id) === Number(variantId) && !isWrapLine(item)
        );
        if (match) {
          return postJson("cart/change.js", {
            id: match.key,
            quantity: Number(match.quantity || 0) + 1,
          });
        }
        return postJson("cart/add.js", { items: [{ id: Number(variantId), quantity: 1 }] });
      })
        .then(readCart)
        .then(syncWrap)
        .then((cart) => {
          adding = false;
          paintAddedSums(cart);
          syncAddedUpsell(cart);
          finishAddedFlash(busyBtn, doneBtn);
        })
        .catch(() => {
          adding = false;
          if (busyBtn) {
            busyBtn.removeAttribute("aria-busy");
            busyBtn.disabled = false;
          }
          location.href = `${window.Shopify.routes.root}cart`;
        });
    };
    const postJson = (path, body) =>
      fetch(`${window.Shopify.routes.root}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      }).then((response) => response.json().then((data) => {
        if (!response.ok || data.status >= 400 || data.errors) throw new Error("cart");
        return data;
      }));
    const readCart = () => fetch(`${window.Shopify.routes.root}cart.js`).then((response) => response.json());
    const syncWrap = (cart) => {
      const wrapId = wrapIdOf();
      if (!wrapId) return Promise.resolve(cart);
      const need = (cart.items || []).reduce((sum, item) => {
        if (isWrapLine(item) || !wantsGift(item)) return sum;
        const itemWrap = Number(propsOf(item)[wrapIdKey] || wrapId);
        return itemWrap === wrapId ? sum + Number(item.quantity || 0) : sum;
      }, 0);
      const wrapLine = (cart.items || []).find((item) => Number(item.variant_id) === wrapId);
      const current = Number(wrapLine?.quantity || 0);
      if (need === current) return Promise.resolve(cart);
      if (need === 0 && wrapLine) {
        return postJson("cart/change.js", { id: wrapLine.key, quantity: 0 }).then(readCart);
      }
      if (need > 0 && !wrapLine) {
        return postJson("cart/add.js", {
          items: [{ id: wrapId, quantity: need, properties: { [wrapMark]: "1" } }],
        }).then(readCart);
      }
      return postJson("cart/change.js", { id: wrapLine.key, quantity: need }).then(readCart);
    };
    const setCartBusy = (on) => {
      root.querySelectorAll(".pdp-cart").forEach((btn) => {
        if (on) btn.setAttribute("aria-busy", "true");
        else btn.removeAttribute("aria-busy");
      });
    };
    let adding = false;
    addedModal?.addEventListener("click", (event) => {
      if (event.target === addedModal || event.target.closest("[data-cart-added-close]")) {
        closeAddedModal();
        return;
      }
      if (event.target.closest("[data-cart-added-back]")) {
        showAddedHome();
        return;
      }
      const pickBtn = event.target.closest("[data-cart-added-pick-add]");
      if (pickBtn) {
        if (!addedPick) return;
        if (pickBtn.getAttribute("aria-busy") === "true" || pickBtn.textContent === addedDoneLabel) return;
        const next = findAddedVariant(addedPick.data, addedPick.selected);
        if (!next?.available) return;
        addUpsellVariant(next.id, pickBtn, pickBtn);
        return;
      }
      const optionBtn = event.target.closest("[data-cart-added-options] button");
      if (optionBtn && addedPick && !optionBtn.disabled) {
        const group = optionBtn.closest(".pdp-options__list");
        if (!group) return;
        addedPick.selected[Number(group.dataset.optionIndex)] = optionBtn.dataset.value;
        paintAddedChoose();
        return;
      }
      const addBtn = event.target.closest("[data-added-add]");
      if (addBtn) {
        if (addBtn.getAttribute("aria-busy") === "true" || addBtn.textContent === addedDoneLabel) return;
        if (addBtn.hasAttribute("data-add-choose")) {
          openAddedChoose(addBtn.closest(".cart-added__item"));
          return;
        }
        addUpsellVariant(addBtn.dataset.addVariant, addBtn, addBtn);
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && addedModal && !addedModal.hidden) {
        if (addedChoose && !addedChoose.hidden) {
          showAddedHome();
          return;
        }
        closeAddedModal();
      }
    });
    const variantModal = document.querySelector("[data-variant-modal]");
    const variantTitle = variantModal?.querySelector("[data-variant-modal-title]");
    const variantOptions = variantModal?.querySelector("[data-variant-modal-options]");
    const variantPrice = variantModal?.querySelector("[data-variant-modal-price]");
    const variantAdd = variantModal?.querySelector("[data-variant-modal-add]");
    let variantState = null;
    const findPicked = (data, selected) =>
      (data.variants || []).find((variant) =>
        (variant.options || []).every((option, index) => option === selected[index])
      );
    const closeVariantModal = () => {
      if (!variantModal) return;
      variantModal.hidden = true;
      if (!addedModal || addedModal.hidden) document.body.classList.remove("is-modal-open");
      variantState = null;
    };
    const paintVariantModal = () => {
      if (!variantState) return;
      const { data, selected } = variantState;
      variantOptions?.querySelectorAll(".pdp-options__list").forEach((group, optionIndex) => {
        group.querySelectorAll("button").forEach((button) => {
          const value = button.dataset.value;
          const possible = (data.variants || []).some((variant) =>
            variant.available
            && variant.options[optionIndex] === value
            && variant.options.every((option, index) => index === optionIndex || option === selected[index])
          );
          button.disabled = !possible;
          button.setAttribute("aria-pressed", selected[optionIndex] === value ? "true" : "false");
        });
      });
      const next = findPicked(data, selected);
      if (variantPrice) variantPrice.textContent = yenAmount(next?.price || 0);
      if (variantAdd && variantAdd.getAttribute("aria-busy") !== "true" && btnLabel(variantAdd) !== addedDoneLabel) {
        variantAdd.disabled = !next?.available;
        variantAdd.textContent = next?.available ? "カートに入れる" : "売り切れ";
      }
    };
    const openVariantModal = (card) => {
      const source = card?.querySelector("[data-variants]");
      if (!source || !variantModal || !variantOptions) return false;
      let data = null;
      try {
        data = JSON.parse(source.textContent);
      } catch {
        return false;
      }
      const first = (data.variants || []).find((variant) => variant.available) || data.variants?.[0];
      if (!first) return false;
      variantState = { card, data, selected: [...(first.options || [])] };
      if (variantTitle) variantTitle.textContent = data.title || "";
      variantOptions.replaceChildren();
      (data.options || []).forEach((option, optionIndex) => {
        const field = document.createElement("fieldset");
        const legend = document.createElement("legend");
        legend.textContent = option.name;
        const list = document.createElement("div");
        list.className = "pdp-options__list";
        list.dataset.optionIndex = String(optionIndex);
        (option.values || []).forEach((value) => {
          const button = document.createElement("button");
          button.type = "button";
          button.dataset.value = value;
          button.textContent = value;
          list.append(button);
        });
        field.append(legend, list);
        variantOptions.append(field);
      });
      paintVariantModal();
      variantModal.hidden = false;
      document.body.classList.add("is-modal-open");
      return true;
    };
    const addShelfVariant = (variantId, btn) => {
      if (!variantId || adding) return;
      if (btn?.getAttribute("aria-busy") === "true" || btnLabel(btn) === addedDoneLabel) return;
      const extra = btn === variantAdd
        ? variantState?.card?.querySelector("[data-add-choose], [data-add-variant]")
        : null;
      const started = Date.now();
      adding = true;
      if (btn) {
        btn.setAttribute("aria-busy", "true");
        btn.disabled = true;
      }
      readCart().then((cart) => {
        const match = (cart.items || []).find((item) =>
          Number(item.variant_id) === Number(variantId) && !isWrapLine(item)
        );
        if (match) {
          return postJson("cart/change.js", {
            id: match.key,
            quantity: Number(match.quantity || 0) + 1,
          });
        }
        return postJson("cart/add.js", { items: [{ id: Number(variantId), quantity: 1 }] });
      })
        .then(readCart)
        .then(syncWrap)
        .then((cart) => {
          const wait = Math.max(0, 350 - (Date.now() - started));
          return new Promise((resolve) => window.setTimeout(() => resolve(cart), wait));
        })
        .then((cart) => {
          adding = false;
          finishAddedBtn(btn);
          if (extra && extra !== btn) finishAddedBtn(extra);
          closeVariantModal();
          openAddedModal(cart);
        })
        .catch(() => {
          adding = false;
          if (btn?.getAttribute("aria-busy") === "true") {
            btn.removeAttribute("aria-busy");
            btn.disabled = false;
          }
        });
    };
    if (variantModal) {
      variantOptions?.addEventListener("click", (event) => {
        const button = event.target.closest("button");
        const group = button?.closest(".pdp-options__list");
        if (!button || !group || !variantState || button.disabled) return;
        variantState.selected[Number(group.dataset.optionIndex)] = button.dataset.value;
        paintVariantModal();
      });
      variantAdd?.addEventListener("click", () => {
        if (!variantState) return;
        if (variantAdd.getAttribute("aria-busy") === "true" || btnLabel(variantAdd) === addedDoneLabel) return;
        const next = findPicked(variantState.data, variantState.selected);
        if (!next?.available) return;
        addShelfVariant(next.id, variantAdd);
      });
      variantModal.addEventListener("click", (event) => {
        if (event.target === variantModal || event.target.closest("[data-variant-modal-close]")) {
          closeVariantModal();
        }
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && variantModal && !variantModal.hidden) closeVariantModal();
      });
    }
    document.addEventListener("click", (event) => {
      const choose = event.target.closest(".pdp-shelf [data-add-choose]");
      if (choose) {
        event.preventDefault();
        if (choose.getAttribute("aria-busy") === "true" || btnLabel(choose) === addedDoneLabel) return;
        openVariantModal(choose.closest(".pdp-card"));
        return;
      }
      const add = event.target.closest(".pdp-shelf [data-add-variant]");
      if (!add) return;
      event.preventDefault();
      addShelfVariant(add.dataset.addVariant, add);
    });
    form?.addEventListener("submit", (event) => {
      event.preventDefault();
      if (adding) return;
      adding = true;
      const variantId = Number(form.querySelector('input[name="id"]').value);
      const wantedGift = Boolean(wrapInput()?.checked);
      const wrapId = wrapIdOf();
      setCartBusy(true);
      const run = () => readCart()
        .then((cart) => {
          const match = (cart.items || []).find((item) =>
            Number(item.variant_id) === variantId
            && !isWrapLine(item)
            && wantsGift(item) === wantedGift
          );
          if (match) {
            return postJson("cart/change.js", {
              id: match.key,
              quantity: Number(match.quantity || 0) + qty,
            });
          }
          const line = { id: variantId, quantity: qty };
          if (wantedGift && wrapId) {
            line.properties = {
              [giftKeyOf()]: giftValueOf(),
              [wrapIdKey]: String(wrapId),
            };
          }
          return postJson("cart/add.js", { items: [line] });
        })
        .then(readCart)
        .then((cart) => {
          const addons = [...root.querySelectorAll("[data-addon]:checked")]
            .filter((input) => !input.hasAttribute("data-gift-wrap"))
            .map((input) => ({
              id: Number(input.dataset.variantId),
              quantity: qty
            }))
            .filter((line) => line.id);
          if (!addons.length) return cart;
          return postJson("cart/add.js", { items: addons }).then(readCart);
        })
        .then(syncWrap)
        .then((cart) => {
          adding = false;
          setCartBusy(false);
          openAddedModal(cart);
        })
        .catch(() => {
          adding = false;
          setCartBusy(false);
          location.href = `${window.Shopify.routes.root}cart`;
        });
      requestAnimationFrame(run);
    });

    const priceEl = root.querySelector("[data-price]");
    const skuEl = root.querySelector("[data-sku]");
    const variantInput = root.querySelector(".pdp-form input[name='id']");
    const cartBtn = root.querySelector("[data-pdp-cart]");
    const cartText = root.querySelector("[data-cart-text]");
    const favs = root.querySelectorAll("[data-pdp-fav]");
    const sticky = root.querySelector("[data-pdp-sticky]");
    const stickyCart = root.querySelector("[data-pdp-sticky-cart]");
    const pdpLinePromo = document.querySelector("[data-line-promo]");
    const stickyText = root.querySelector("[data-sticky-cart-text]");
    const stickyOverlays = [
      document.querySelector("[data-reviews-overlay]"),
      document.querySelector("[data-review-photo-overlay]"),
      document.querySelector("[data-gift-modal]"),
      document.querySelector("[data-variant-modal]"),
      document.querySelector("[data-cart-added]")
    ];
    let cartPassed = false;
    const paintCartLabel = (el, available) => {
      if (!el) return;
      el.classList.add("pdp-cart__label");
      if (!available) {
        el.textContent = cartBtn?.dataset.cartLabelSold || "売り切れ";
        return;
      }
      const label = cartBtn?.dataset.cartLabelAdd || "カートに入れる";
      const tail = "に入れる";
      if (!label.endsWith(tail)) {
        el.textContent = label;
        return;
      }
      const head = document.createElement("span");
      head.className = "pdp-cart__head";
      head.textContent = label.slice(0, -tail.length);
      const span = document.createElement("span");
      span.className = "pdp-cart__tail";
      span.textContent = tail;
      el.replaceChildren(head, span);
    };

    const syncSticky = () => {
      if (!sticky) return;
      const overlayOpen = stickyOverlays.some((el) => el && !el.hidden);
      const show = cartPassed && !overlayOpen;
      sticky.hidden = false;
      sticky.classList.toggle("is-in", show);
      sticky.setAttribute("aria-hidden", show ? "false" : "true");
      if (pdpLinePromo && !pdpLinePromo.hidden) {
        pdpLinePromo.classList.add("is-ready");
        pdpLinePromo.classList.toggle("is-in", show);
      }
      const width = show ? Math.ceil(sticky.getBoundingClientRect().width) : 0;
      document.documentElement.style.setProperty("--pdp-sticky-w", `${width}px`);
    };
    const updateCartPassed = (rect) => {
      cartPassed = (rect || cartBtn.getBoundingClientRect()).bottom < 0;
      syncSticky();
    };
    stickyCart?.addEventListener("click", () => {
      if (!form || cartBtn?.disabled || adding) return;
      if (typeof form.requestSubmit === "function") form.requestSubmit(cartBtn);
      else cartBtn?.click();
    });
    if (cartBtn && sticky) {
      const watchCart = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (entry) updateCartPassed(entry.boundingClientRect);
      });
      watchCart.observe(cartBtn);
      const watchOverlays = new MutationObserver(syncSticky);
      stickyOverlays.forEach((el) => {
        if (el) watchOverlays.observe(el, { attributes: true, attributeFilter: ["hidden"] });
      });
      window.addEventListener("scroll", () => updateCartPassed(), { passive: true });
      window.addEventListener("resize", () => updateCartPassed());
      updateCartPassed();
    }
    const selected = [];
    root.querySelectorAll(".pdp-options__list").forEach((group) => {
      const pressed = group.querySelector('[aria-pressed="true"]');
      selected[Number(group.dataset.optionIndex)] = pressed?.dataset.value || "";
    });

    const findVariant = () =>
      product.variants.find((variant) =>
        (variant.options || []).every((option, index) => option === selected[index])
      );

    const renderVariant = () => {
      const next = findVariant();
      if (!next) return;
      if (priceEl) priceEl.textContent = next.price_label;
      if (skuEl) skuEl.textContent = next.sku || skuEl.textContent;
      if (variantInput) variantInput.value = String(next.id);
      favs.forEach((fav) => fav.setAttribute("data-variant-id", String(next.id)));
      const available = Boolean(next.available);
      if (cartBtn) cartBtn.disabled = !available;
      if (stickyCart) stickyCart.disabled = !available;
      paintCartLabel(cartText, available);
      paintCartLabel(stickyText, available);
      if (next.image_id) {
        const thumbIndex = thumbs.findIndex((thumb) => thumb.dataset.imageId === String(next.image_id));
        if (thumbIndex >= 0) showImage(thumbIndex);
      }
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(next.id));
      window.history.replaceState({}, "", url);
    };

    root.querySelectorAll(".pdp-options__list").forEach((group) => {
      group.addEventListener("click", (event) => {
        const button = event.target.closest("button");
        if (!button) return;
        group.querySelectorAll("button").forEach((item) => item.setAttribute("aria-pressed", "false"));
        button.setAttribute("aria-pressed", "true");
        selected[Number(group.dataset.optionIndex)] = button.dataset.value;
        renderVariant();
      });
    });

    const tabs = root.querySelector("[data-tabs]");
    const bindTabs = (box) => {
      box.querySelectorAll('[role="tab"]').forEach((tab) => {
        tab.addEventListener("click", () => {
          box.querySelectorAll('[role="tab"]').forEach((item) => item.setAttribute("aria-selected", "false"));
          box.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.hidden = true;
          });
          tab.setAttribute("aria-selected", "true");
          const panel = document.getElementById(tab.getAttribute("aria-controls"));
          if (panel) panel.hidden = false;
        });
      });
    };
    const buildTabsFromBody = (box) => {
      const source = box.querySelector("[data-tabs-source]");
      if (!source) return;
      const parts = [];
      let current = null;
      [...source.childNodes].forEach((node) => {
        if (node.nodeType === 1 && node.tagName === "H2") {
          const title = node.textContent.replace(/\s+/g, " ").trim();
          if (!title) return;
          current = { title, nodes: [] };
          parts.push(current);
          return;
        }
        if (node.nodeType === 1 && node.matches?.(".metafield-rich_text_field")) {
          [...node.childNodes].forEach((child) => {
            if (child.nodeType === 1 && child.tagName === "H2") {
              const title = child.textContent.replace(/\s+/g, " ").trim();
              if (!title) return;
              current = { title, nodes: [] };
              parts.push(current);
              return;
            }
            if (child.nodeType === 3 && !child.textContent.trim()) return;
            if (!current) {
              current = { title: "商品説明", nodes: [] };
              parts.push(current);
            }
            current.nodes.push(child);
          });
          return;
        }
        if (node.nodeType === 3 && !node.textContent.trim()) return;
        if (!current) {
          current = { title: "商品説明", nodes: [] };
          parts.push(current);
        }
        current.nodes.push(node);
      });
      source.remove();
      if (!parts.length) {
        box.hidden = true;
        return;
      }
      box.style.setProperty("--pdp-tabs", String(parts.length));
      const prefix = box.dataset.tabsId || "pdp";
      const nav = document.createElement("div");
      nav.className = "pdp-tabs__nav";
      nav.setAttribute("role", "tablist");
      nav.setAttribute("aria-label", "商品情報");
      const frag = document.createDocumentFragment();
      frag.append(nav);
      parts.forEach((part, index) => {
        const tabId = `pdp-tab-${prefix}-${index}`;
        const panelId = `pdp-panel-${prefix}-${index}`;
        const tab = document.createElement("button");
        tab.type = "button";
        tab.id = tabId;
        tab.setAttribute("role", "tab");
        tab.setAttribute("aria-controls", panelId);
        tab.setAttribute("aria-selected", index === 0 ? "true" : "false");
        tab.textContent = part.title;
        nav.append(tab);
        const panel = document.createElement("div");
        panel.id = panelId;
        panel.className = "pdp-tabs__panel miipas-rte";
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("aria-labelledby", tabId);
        if (index) panel.hidden = true;
        part.nodes.forEach((node) => panel.append(node));
        frag.append(panel);
      });
      box.append(frag);
    };
    if (tabs) {
      buildTabsFromBody(tabs);
      bindTabs(tabs);
    }
  });
